import { useEffect, useState } from "react";

export const InvalidEventList = () => {

    const [listCount, setListCount] = useState(0);

    useEffect(() => {
        getdata()
    })


    const getdata = async () => {
        let reqBody = {}
        const requestOptions = {
            method: "POST",
            headers: { "Content-type": "application/json" },
            body: JSON.stringify(reqBody),
        };
        const response = await fetch(process.env.REACT_APP_PECE_DEV_URL + "calendarapi/invalid-event-count", requestOptions);
        const respdata = await response.json();
        console.log("Invalid Event List ", respdata);
        if (respdata && respdata.count) {
            setListCount(respdata.count)
        }
    }

    return (
        <div> Invalid Event List Count : {listCount}</div>
    )
}